import React from "react";
import "../styles/home.css";
import NavHero from "../components/NavHero";
import Welcome from "../components/Welcome";
import OurServices from "../components/OurServices";
import Why from "../components/WhyNexa";
import WhoWeServe from "../components/WhoWeServe";
import Impact from "../components/ImpactSection";
// import BottomHeroSection from "../components/HeroSection2";

const Home = () => {
  return (
    <div className="home">
      <NavHero />
      <Welcome />
      <OurServices />
      <Why />
      <WhoWeServe />
      <Impact />
    </div>
  );
};

export default Home;
